import { styled } from "@mui/system";

const StyledContainer = styled("div")(
  ({
    theme,
    align,
    noJustify,
    end,
    start,
    center,
    minGap,
    noGap,
    halfGap,
    padding,
    relative,
  }) => ({
    display: "flex",
    gap: `${
      halfGap
        ? theme.space.main
        : minGap
        ? theme.space.half
        : noGap
        ? 0
        : theme.space.double
    }`,
    justifyContent: `${
      noJustify
        ? "initial"
        : center
        ? "center"
        : end
        ? "flex-end"
        : start
        ? "flex-start"
        : "space-between"
    }`,
    alignItems: `${
      align === "end"
        ? "flex-end"
        : align === "start"
        ? "flex-start"
        : align === "center"
        ? "center"
        : "stretch"
    }`,
    padding: `${padding ? padding : "0"} `,
    position: `${relative ? "relative" : "initial"}`,
  })
);

export default function RowContainer({ children, className, ...props }) {
  return (
    <StyledContainer className={className} {...props}>
      {children}
    </StyledContainer>
  );
}
